import * as actionTypes from "../actions/actionTypes";

const initialState = {feedback: []};

const submitFeedBackReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_FEEDBACK:
      return {
        ...state,
        feedback: [action.payload.feedback],
      };

    default:
      return state;
  }
};
export default submitFeedBackReducer;
